import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {FormBuilder, FormGroup} from "@angular/forms";

import {MessageService, ProcedureService,ReportService} from "@services";

@Component({
  selector: 'app-reports-consultation-cc',
  templateUrl: './reports-consultation-cc.component.html',
  styleUrls: ['./reports-consultation-cc.component.scss']
})
export class ReportsConsultationCcComponent implements  AfterViewInit {

  /**
   * Paginador de la bandeja
   */
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Objeto para ordenar los tramites de la bandeja
   */
  @ViewChild(MatSort) sort: MatSort;

  public validatorForm: FormGroup;

  tableFilter: any[] = [];

  showFormByUser: boolean = false;

  tramiteSeleccionado: any;

  /**
   * Opciones para el total de registros por página
   */
  public pageSizeOptions: number[] = [10, 25, 50, 100];

  /**
   * Número total de solicitudes
   */
  public totalRequests: number;


  constructor(private fb: FormBuilder,
              private procedureService: ProcedureService,
              private popUpService: MessageService,
              private reportService: ReportService) {
    this.validatorForm = this.fb.group({
      identificationNumber: [''],
      textToSearch: [''],
      pageSize: [10],
      pageNumber: [1],
    });
  }


  /**
   * Hook cuando el componente ya renderizó todas las vistas
   */
  ngAfterViewInit() {
    this.paginator._intl.getRangeLabel = this.getRangeDisplayText;
  }


  getListaTramites() {
    let data = {
      identificationNumber: this.validatorForm.get('identificationNumber').value,
      pageSize: this.validatorForm.get('pageSize').value,
      pageNumber: this.validatorForm.get('pageNumber').value,
      textToSearch: this.validatorForm.get('textToSearch').value,
    };

    this.popUpService.infoAlert('Buscando tramites...', 8000);
    this.reportService.getFilterReport(data).subscribe((values) => {

      this.tableFilter = values['items'];
      this.totalRequests = values['totalRows'];

      if (this.tableFilter.length == 0) {
        this.popUpService.errorAlert("No hay registros para el documento ingresado.", 4000);
      }

    });
  }

  /**
   * Cambia la página en la tabla actualizando su información
   * @param e Evento del paginador
   */
  cambiarpagina(e: PageEvent) {
    this.validatorForm.get('pageNumber').setValue(e.pageIndex + 1);
    this.getListaTramites();
  }

  /**
   * Actualiza la lista de solicitudes
   */
  public changeDataTable(): void {
    this.validatorForm.get('pageNumber').setValue(1);
    this.paginator.firstPage();
    this.getListaTramites();
  }

  getTramiteActual(id): void {
    this.popUpService.infoAlert('Cargando tramite...', 4000);

    this.procedureService.getById(id).subscribe((resp) => {
      this.tramiteSeleccionado = resp;
      this.showFormByUser = true;
    });
  }

  changeColor(diaspasados, i) {
    let mensajeDias = "";
    let color = document.getElementById(`color_${i}`);
    if (diaspasados <= 9) {
      mensajeDias = `Quedan ` + (9 - diaspasados) + ` días. Días transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor = "#d1e7dd";
    } else if (diaspasados >= 10 && diaspasados <= 14) {
      mensajeDias = `¡Atención usuario! Trámite próximo a vencerse. quedan ` + (14 - diaspasados) + `. Dias transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor = "#fff3cd";
    } else if (diaspasados >= 15 && diaspasados <= 20) {
      mensajeDias = `¡Atención usuario! Trámite próximo a vencerse. quedan ` + (20 - diaspasados) + `. Dias transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor = "#f8d7da";
    } else {
      mensajeDias = `¡Atención usuario! El trámite se encuentra vencido. Dias transcurridos ${diaspasados}`;
      // tslint:disable-next-line: no-unused-variable
      (<HTMLElement>color).style.backgroundColor = "#f8d7da";
    }
    return mensajeDias;
  }

  public cancelFrm() {
    this.showFormByUser = false;
  }

  sortAscDes(nameData, type) {
    this.tableFilter.sort((x, y) => {
      let a = x[nameData].toLowerCase();
      let b = y[nameData].toLowerCase();
      let operaction;
      if (type === 'up') {
        // tslint:disable-next-line: no-unused-variable
        operaction = (a > b) ? 1 : (a == b) ? 0 : -1;
      } else {
        // tslint:disable-next-line: no-unused-variable
        operaction = (a > b) ? -1 : (a == b) ? 0 : 1;
      }
      return operaction;
    })
  }

  sortAscDesNumber(nameData, type) {
    this.tableFilter.sort((x, y) => {
      let a = x[nameData];
      let b = y[nameData];
      let operaction;
      if (type === 'up') {
        // tslint:disable-next-line: no-unused-variable
        operaction = (a > b) ? 1 : (a == b) ? 0 : -1;
      } else {
        // tslint:disable-next-line: no-unused-variable
        operaction = (a > b) ? -1 : (a == b) ? 0 : 1;
      }
      return operaction;
    })
  }


  /**
   * Modifica el texto del label del paginador, cantidad de registros por pagina
   * @param page
   * @param pageSize
   * @param length
   */
  private getRangeDisplayText = (page: number, pageSize: number, length: number) => {
    const initialText = `Ver trámites`; // customize this line
    if (length == 0 || pageSize == 0) {
      return `${initialText} 0 of ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${initialText} ${startIndex + 1} a ${endIndex} de ${length}`; // customize this line
  };

}
